import ProductsListScreen from "@/UI/screens/ProductsListScreen";

export default function ProductsListRoute() {
    return <ProductsListScreen />;
}
